// extracted by mini-css-extract-plugin
export var banner = "_ee-0";
export var closeButton = "_ee-2";
export var greenCheckmark = "_ee-3";
export var hereLink = "_ee-4";
export var titleIcon = "_ee-1";